module.exports = __webpack_public_path__ + "img/toast2.41ca3342.png";